// extracted by mini-css-extract-plugin
export default {"details_categories_item":"style_details_categories_item__0Fp+G","details_simple":"style_details_simple__STT0W"};